<template>
  <div class="publicizeList">
    <div class="banner">
      <img :src="bannerStr" alt="">
      <div class="weizhi">
        <i class="iconfont icon-dizhi"></i> 当前位置：{{bannerTex}}
      </div>
    </div>
    <div class="bgc">
      <div class="bx-content">
        <div class="back">
          <b></b>
          <span @click="$router.go(-1)">
            <i class="iconfont icon-prev_arrow-copy"></i>返回
          </span>
        </div>

        <div class="list-box">
          <div class="search-box">
            <input type="text" v-model="search.keyword" placeholder="输入名称搜索">
            <div class="btn" @click="searchFun">
              <i class="iconfont icon-sousuo2"></i> 检索
            </div>
          </div>

          <div class="org-list">
<!--            <div class="yj-itm">-->
<!--              <div class="xh">序号</div>-->
<!--              <div class="nme">机构名称</div>-->
<!--              <div class="sta">预警状态</div>-->
<!--              <div class="dtl">预警情形</div>-->
<!--            </div>-->
            <div class="yj-itm height" v-for="item in lists" :key="item.id" @click="showMask(item)">
<!--              <div class="xh">{{index + 1}}</div>-->
              <div class="nme">{{item.org_name}}</div>
<!--              <div class="sta">{{item.warning}}</div>-->
<!--              <div class="dtl">{{item.content}}</div>-->
            </div>
          </div>
        </div>

<!--        <div class="masses-pagebox">-->
<!--          <el-pagination-->
<!--            :current-page.sync="search.page"-->
<!--            :page-size="search.limit"-->
<!--            :total="search.total"-->
<!--            background-->
<!--            class="page-all margin-top self-end"-->
<!--            layout="prev, pager, next"-->
<!--            @current-change="list">-->
<!--          </el-pagination>-->
<!--        </div>-->
      </div>
    </div>
    <orgDetailDialog :dialogVisible="dialogVisible" :item="item" @handleClose="handleClose" />
  </div>
</template>
<script>
import {masses_star_lst} from "@/api";
import orgDetailDialog from "@/views/masses/common/orgDetailDialog";
export default {
  name: "policyList",
  data() {
    return {
      dialogVisible:false,
      item:{},
      type: 1,
      bannerTex:'风险预警机构名单',
      bannerStr:require('@/assets/images/yujing.jpg'),
      search:{
        keyword:'',
        page:1,
        limit:30,
        total:0,
      },
      lists:[]
    }
  },
  components: {orgDetailDialog},
  created() {
    this.type = this.$route.query.type
    // this.bannerFun()
    this.list()
  },
  methods: {
    async list(){
      let _data = await masses_star_lst(
        3,
        1,
        9999999
      );
      this.lists = _data.data;
    },
    showMask(item) {
      this.item = item;
      this.dialogVisible = true;
    },
    searchFun(){
      this.search.page = 1
      this.list()
    },
    bannerFun(){
      switch (Number(this.type)) {
        case 1:
          this.bannerTex = '首页 > 海淀区已取得科技类《非学科类校外培训机构培训许可证》机构名单及星级评定情况'
          this.bannerStr = require('@/assets/images/yiqu.jpg')
          break;
        case 2:
          this.bannerTex = '首页 > 海淀区未取得科技类《非学科类校外培训机构培训许可证》机构名单及星级评定情况'
          this.bannerStr = require('@/assets/images/weiqu.jpg')
          break;
        default:
          this.bannerTex = '首页 > 详情'
          this.bannerStr = require('@/assets/images/indexbanner.jpg')
          break;
      }
    },
    handleClose(){
      this.dialogVisible = false
      this.item = {}
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.publicizeList {
  .item-child {
    width: 458px;
    height: 70px;
    background-color: #ffffff;
    box-shadow: 0px 0px 16px 0px
    rgba(7, 65, 149, 0.05);
    border-radius: 10px;
    padding: 0 20px;
    margin: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .child-tex {
      flex: 1;
      width: 0;
      margin-right: 12px;
      font-size: 19px;
      color: #64676d;
      cursor: pointer;
    }
    .child-start {
      width: max-content;
      display: flex;
      justify-content: flex-end;
      i {
        font-size: 22px;
        color: #fcd822;
        margin: 0 3px;
      }
    }
  }
  .bgc {
    width: 100%;
    padding-bottom: 50px;
    background-image: linear-gradient(0deg,
      #ffffff 0%,
      #ebf4ff 100%);
    .list-box {
      width: 100%;
      background-image: linear-gradient(180deg,
        #e1eeff 0%,
        #ffffff 100%);
      box-shadow: 11px 8px 18px 0px
      rgba(0, 46, 108, 0.17);
      border-radius: 8px;
      border: solid 1px #ffffff;
      .search-box {
        width: 1102px;
        height: 100px;
        background-color: #ffffff;
        box-shadow: 1px 3px 10px 0px
        rgba(2, 28, 58, 0.28);
        border-radius: 10px;
        margin: 30px auto;
        padding: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .btn {
          width: 163px;
          height: 84px;
          background-color: #2d94ff;
          border-radius: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 24px;
          color: #ffffff;
          cursor: pointer;
          i {
            color: #ffffff;
            font-size: 30px;
            margin-right: 10px;
          }
        }
        input {
          padding: 0 30px;
          height: 80px;
          font-size: 28px;
          color: #333333;
        }
      }
      padding: 30px;
      .org-list {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        .yj-itm {
          width: 33%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          .dtl {
            flex: 1;
            width: 0;
            height: 50px;
            background-color: #ffffff;
            box-shadow: 0px 0px 16px 0px
            rgba(7, 65, 149, 0.05);
            border-radius: 10px;
            font-size: 20px;
            color: #64676d;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 10px;
          }
          .sta {
            width: 152px;
            height: 50px;
            background-color: #ffffff;
            box-shadow: 0px 0px 16px 0px
            rgba(7, 65, 149, 0.05);
            border-radius: 10px;
            font-size: 20px;
            color: #64676d;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 15px;
          }
          .nme {
            width: 468px;
            height: 50px;
            background-color: #ffffff;
            box-shadow: 0px 0px 16px 0px
            rgba(7, 65, 149, 0.05);
            border-radius: 10px;
            margin: 0 15px;
            font-size: 20px;
            color: #64676d;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 10px;
          }
          .xh {
            width: 96px;
            height: 50px;
            background-color: #ffffff;
            box-shadow: 0px 0px 16px 0px
            rgba(7, 65, 149, 0.05);
            border-radius: 10px;
            font-size: 20px;
            color: #64676d;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          &.height {
            .xh {
              height: 88px;
            }
            .nme {
              height: 88px;
            }
            .sta {
              height: 88px;
            }
            .dtl {
              height: 88px;
            }
          }
        }
        .org {
          width: 466px;
          height: 70px;
          background-color: #ffffff;
          box-shadow: 0px 0px 16px 0px
          rgba(7, 65, 149, 0.05);
          border-radius: 10px;
          margin-right: 20px;
          margin-top: 20px;
          font-size: 22px;
          color: #64676d;
          padding: 0 30px;
          line-height: 70px;
          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
    .back {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;
      span {
        font-size: 18px;
        color: #428ffb;
        width: 105px;
        height: 45px;
        border-radius: 22px;
        border: solid 1px #428ffb;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        i {
          font-size: 20px;
          margin-right: 5px;
          color: #428ffb;
        }
      }
    }
  }
  .banner {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      height: auto;
    }
    .weizhi {
      width: 1500px;
      position: absolute;
      bottom: 20px;
      left: 50%;
      margin-left: -750px;
      font-size: 18px;
      letter-spacing: 1px;
      color: #ffffff;
      i {
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
}
</style>


